import React from 'react';
import classes from 'components/SmallLoader/style.module.scss';

const Loader = () => <div className={classes.wrapper}>
  <div className={classes.loader}/>
</div>

export default Loader;
